var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.2794 16.7711C23.2249 23.8027 16.6416 26.7841 10.5744 25.1612C4.50716 23.5384 0.949114 17.1547 2.62726 10.9028C4.30541 4.65098 10.5843 0.898414 16.6515 2.52125C22.7187 4.14408 26.747 8.56761 25.2794 16.7711Z",
  fill: "url(#paint0_linear_35426_3734)"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.7752 16.9693C23.9978 23.5905 17.332 27.602 10.8523 25.8688C4.37256 24.1356 0.608986 17.3346 2.38629 10.7133C4.1636 4.09208 10.8295 0.0806586 17.3092 1.81382C23.7889 3.54697 27.5525 10.348 25.7752 16.9693ZM11.0422 25.1613C17.1094 26.7841 23.3882 23.0316 25.0664 16.7797C26.7445 10.5278 23.1865 4.14415 17.1193 2.52132C11.0521 0.898485 4.77319 4.65105 3.09504 10.9029C1.4169 17.1548 4.97494 23.5385 11.0422 25.1613Z",
  fill: "url(#paint1_linear_35426_3734)"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.8644 16.0523C22.1863 22.3041 15.9074 26.0567 9.8402 24.4338C3.77298 22.811 0.214934 16.4273 1.89308 10.1755C3.57123 3.9236 9.8501 0.171034 15.9173 1.79386C21.9845 3.4167 25.5426 9.80039 23.8644 16.0523Z",
  fill: "url(#paint2_linear_35426_3734)"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5735 16.2405C22.7962 22.8617 16.1303 26.8731 9.65058 25.14C3.17088 23.4068 -0.592687 16.6058 1.18462 9.98452C2.96192 3.36326 9.62782 -0.648157 16.1075 1.085C22.5872 2.81816 26.3508 9.6192 24.5735 16.2405ZM9.84049 24.4325C15.9077 26.0553 22.1866 22.3027 23.8647 16.0509C25.5429 9.79903 21.9848 3.41533 15.9176 1.7925C9.85038 0.169669 3.57152 3.92224 1.89337 10.1741C0.215222 16.426 3.77327 22.8097 9.84049 24.4325Z",
  fill: "url(#paint3_linear_35426_3734)"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5735 16.2405C22.7962 22.8617 16.1303 26.8731 9.65058 25.14C3.17088 23.4068 -0.592687 16.6058 1.18462 9.98452C2.96192 3.36326 9.62782 -0.648157 16.1075 1.085C22.5872 2.81816 26.3508 9.6192 24.5735 16.2405ZM9.84049 24.4325C15.9077 26.0553 22.1866 22.3027 23.8647 16.0509C25.5429 9.79903 21.9848 3.41533 15.9176 1.7925C9.85038 0.169669 3.57152 3.92224 1.89337 10.1741C0.215222 16.426 3.77327 22.8097 9.84049 24.4325Z",
  fill: "black",
  fillOpacity: 0.1
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.7383 15.4798C20.3748 20.5594 15.303 23.6164 10.41 22.3076C5.51712 20.9989 2.65596 15.8201 4.01945 10.7405C5.38295 5.66083 10.4548 2.60391 15.3477 3.91264C20.2406 5.22138 23.1018 10.4002 21.7383 15.4798Z",
  fill: "url(#paint4_radial_35426_3734)"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.4464 15.6719C20.9851 21.1159 15.5297 24.438 10.2194 23.0177C4.90915 21.5973 1.84872 15.9974 3.31001 10.5534C4.7713 5.10946 10.2266 1.78731 15.5369 3.20769C20.8472 4.62806 23.9076 10.228 22.4464 15.6719ZM10.4094 22.3102C15.3023 23.6189 20.3741 20.562 21.7376 15.4824C23.1011 10.4027 20.2399 5.22392 15.347 3.91518C10.4541 2.60645 5.38226 5.66337 4.01877 10.743C2.65527 15.8226 5.51643 21.0014 10.4094 22.3102Z",
  fill: "url(#paint5_linear_35426_3734)"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.4464 15.6719C20.9851 21.1159 15.5297 24.438 10.2194 23.0177C4.90915 21.5973 1.84872 15.9974 3.31001 10.5534C4.7713 5.10946 10.2266 1.78731 15.5369 3.20769C20.8472 4.62806 23.9076 10.228 22.4464 15.6719ZM10.4094 22.3102C15.3023 23.6189 20.3741 20.562 21.7376 15.4824C23.1011 10.4027 20.2399 5.22392 15.347 3.91518C10.4541 2.60645 5.38226 5.66337 4.01877 10.743C2.65527 15.8226 5.51643 21.0014 10.4094 22.3102Z",
  fill: "#1A5F46",
  fillOpacity: 0.7
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6897 6.59219C18.6817 5.69546 17.4626 5.01778 16.0816 4.6484C11.1887 3.33966 6.11684 6.39658 4.75334 11.4762C3.87348 14.7541 4.7528 18.0732 6.80205 20.3671C4.2387 18.0867 3.04093 14.3897 4.01958 10.7438C5.38308 5.66412 10.4549 2.6072 15.3478 3.91594C17.0834 4.38015 18.5633 5.33128 19.6897 6.59219Z",
  fill: "url(#paint6_linear_35426_3734)"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6897 6.59219C18.6817 5.69546 17.4626 5.01778 16.0816 4.6484C11.1887 3.33966 6.11684 6.39658 4.75334 11.4762C3.87348 14.7541 4.7528 18.0732 6.80205 20.3671C4.2387 18.0867 3.04093 14.3897 4.01958 10.7438C5.38308 5.66412 10.4549 2.6072 15.3478 3.91594C17.0834 4.38015 18.5633 5.33128 19.6897 6.59219Z",
  fill: "#1A5F46",
  fillOpacity: 0.7
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.804 9.60954C2.6142 9.53874 2.51783 9.32776 2.58875 9.13829C3.85511 5.7554 6.69104 3.13734 10.2132 2.16696C10.4085 2.11315 10.6105 2.22758 10.6644 2.42255C10.7183 2.61753 10.6037 2.81921 10.4084 2.87302C7.11474 3.78045 4.46072 6.23009 3.27609 9.39468C3.20516 9.58414 2.9938 9.68034 2.804 9.60954Z",
  fill: "#82EDBA",
  fillOpacity: 0.7
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0202 18.6621C22.1915 18.7701 22.2426 18.9963 22.1344 19.1673C21.2762 20.5235 20.1383 21.6855 18.8015 22.5728C18.6328 22.6848 18.405 22.639 18.2929 22.4706C18.1807 22.3021 18.2265 22.0748 18.3952 21.9628C19.6461 21.1326 20.7111 20.0451 21.5141 18.7762C21.6223 18.6052 21.8489 18.5541 22.0202 18.6621Z",
  fill: "#8AEAB1",
  fillOpacity: 0.7
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.84524 4.62772C6.84517 4.62777 6.84532 4.62767 6.84524 4.62772L6.64174 4.323C6.84524 4.62772 6.84519 4.62775 6.84524 4.62772L6.84392 4.6286L6.83648 4.63366C6.82954 4.63841 6.8187 4.64588 6.80431 4.656C6.77553 4.67624 6.73263 4.70701 6.67842 4.74759C6.5699 4.82884 6.41672 4.94895 6.24129 5.10218C5.88839 5.41041 5.45526 5.84422 5.11261 6.35729C5.00021 6.52558 4.77243 6.57105 4.60384 6.45886C4.43525 6.34666 4.38969 6.11928 4.50209 5.95099C4.89319 5.36537 5.37725 4.88361 5.75811 4.55094C5.94956 4.38372 6.11739 4.25205 6.23817 4.16163C6.29861 4.11637 6.34743 4.08134 6.3817 4.05723C6.39885 4.04517 6.41237 4.03584 6.42191 4.02932L6.43319 4.02166L6.4365 4.01943L6.43757 4.01872C6.43763 4.01867 6.43823 4.01827 6.64174 4.323L6.43757 4.01872C6.60616 3.90652 6.8346 3.95156 6.947 4.11985C7.05934 4.28807 7.01365 4.51547 6.84524 4.62772Z",
  fill: "#9DF9C2"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.7028 8.18884C14.571 8.16119 14.44 8.18084 14.3278 8.23638C14.245 8.13767 14.1311 8.06885 14.0036 8.0421L13.1283 7.85839C12.8199 7.79367 12.5163 7.98774 12.4457 8.29476L12.2543 9.12615L12.2523 9.12572L11.0443 8.87184C10.7358 8.807 10.4321 9.00123 10.3615 9.30845L10.1552 10.2068C10.12 10.3598 10.1487 10.5205 10.2344 10.6519C10.3202 10.7833 10.4558 10.8741 10.61 10.9036L10.6372 10.9088L10.7096 10.9227C10.7697 10.9344 10.8493 10.9499 10.9281 10.9657C11.0078 10.9816 11.0835 10.9971 11.1372 11.0088L11.1642 11.0149L10.8485 12.3883L10.8466 12.3967L10.4021 14.329L10.3188 14.311C10.2399 14.2938 10.1605 14.2762 10.1006 14.2628L10.0017 14.2407C9.72781 14.1789 9.44861 14.3226 9.34025 14.5816L8.93526 15.5496C8.86875 15.7086 8.87663 15.8889 8.95676 16.0414C9.03689 16.1939 9.18091 16.3026 9.34957 16.338L10.4887 16.577L10.5388 16.5876L10.3485 17.4163C10.3138 17.5675 10.3413 17.7263 10.4249 17.8569C10.5084 17.9875 10.641 18.0791 10.7928 18.111L11.6677 18.2947C11.7996 18.3224 11.9306 18.3027 12.0429 18.2472C12.1256 18.3459 12.2396 18.4147 12.3671 18.4415L13.243 18.6252C13.5513 18.6898 13.8548 18.4958 13.9255 18.1888L14.1293 17.303C14.7105 17.358 15.2763 17.344 15.7772 17.1807C16.4814 16.9511 16.9977 16.4467 17.2686 15.6336C17.4751 15.0141 17.4838 14.4399 17.2387 13.9404C17.1583 13.7765 17.0562 13.6322 16.9386 13.5048C16.961 13.4828 16.983 13.4601 17.0045 13.4366C17.2862 13.1297 17.4547 12.7326 17.5136 12.2634C17.6034 11.5555 17.3509 10.9888 16.8956 10.5724C16.5976 10.2998 16.2212 10.0982 15.822 9.94196L16.0231 9.06732C16.0579 8.9161 16.0304 8.75729 15.9468 8.62662C15.8632 8.49595 15.7305 8.40439 15.5787 8.37254L14.7028 8.18884Z",
  fill: "#017654"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5075 11.8146C16.6368 10.7975 15.8181 10.2756 14.7095 9.94324L15.0272 8.56141L14.1513 8.37772L13.842 9.72313C13.6117 9.67485 13.3754 9.62983 13.1405 9.58524L13.452 8.23096L12.5767 8.04725L12.2587 9.42861C12.0682 9.39254 11.8812 9.35685 11.6996 9.31886L11.7005 9.31455L10.4926 9.06067L10.2863 9.95905C10.2863 9.95905 10.9358 10.0829 10.9224 10.0921C11.2771 10.1666 11.3471 10.3887 11.3414 10.5664L10.9796 12.1406L10.9782 12.1466L10.471 14.3518C10.4307 14.4558 10.3258 14.6129 10.0778 14.5613C10.0869 14.5732 9.44121 14.4276 9.44121 14.4276L9.03622 15.3956L10.176 15.6347C10.3881 15.6794 10.596 15.7267 10.8006 15.7709L10.4796 17.1686L11.3545 17.3523L11.6724 15.9695C11.9115 16.0247 12.1436 16.0753 12.3706 16.1227L12.0537 17.499L12.9296 17.6827L13.2506 16.2877C14.7417 16.5156 15.8543 16.3756 16.2876 15.0745C16.6367 14.027 16.2227 13.4399 15.4312 13.0718C15.996 12.93 16.4141 12.5591 16.5075 11.8146ZM11.9268 14.9567C11.9758 14.967 12.0333 14.9798 12.0976 14.9942C12.8126 15.1543 14.3751 15.504 14.595 14.5458C14.8204 13.5659 13.3066 13.2841 12.5679 13.1466C12.4853 13.1312 12.4125 13.1176 12.3528 13.1051L11.9268 14.9567ZM12.5477 12.2575C13.0421 12.3612 14.5696 12.798 14.7884 11.8478C15.0161 10.8567 13.4283 10.6818 12.9339 10.5781L12.5477 12.2575Z",
  fill: "white"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7091 9.94311C15.8178 10.2755 16.6365 10.7973 16.5071 11.8145C16.4443 12.3157 16.2342 12.6476 15.9313 12.8543C15.7843 12.9546 15.6154 13.0253 15.4308 13.0717C15.6099 13.155 15.7697 13.2495 15.9057 13.358C16.3707 13.7291 16.5574 14.2639 16.2872 15.0744C15.8539 16.3754 14.7414 16.5154 13.2503 16.2876L12.9292 17.6826L12.0534 17.4989L12.3702 16.1226C12.2327 16.0938 12.0932 16.0639 11.9515 16.0325C11.8899 16.0189 11.8279 16.005 11.7654 15.9908C11.7345 15.9837 11.7034 15.9766 11.6722 15.9694C11.6722 15.9694 11.6723 15.9694 11.6722 15.9694L11.3541 17.3522L10.4792 17.1684L10.8002 15.7708C10.7185 15.7531 10.6362 15.735 10.5533 15.7167C10.4965 15.7041 10.4393 15.6915 10.3819 15.679C10.3136 15.664 10.2449 15.6492 10.1757 15.6346L9.03587 15.3954L9.44086 14.4275C9.44086 14.4275 9.53879 14.4495 9.65784 14.4758C9.65787 14.4758 9.65781 14.4758 9.65784 14.4758C9.83553 14.515 10.0603 14.5636 10.0766 14.5619C10.3085 14.6101 10.4162 14.4751 10.462 14.3725C10.4651 14.3654 10.468 14.3584 10.4706 14.3517L10.9779 12.1464L10.9792 12.1405L11.3411 10.5663C11.3436 10.487 11.3311 10.399 11.2851 10.3192C11.2278 10.2199 11.1187 10.1333 10.922 10.092C10.9223 10.0918 10.9222 10.0922 10.922 10.092C10.9219 10.0917 10.9217 10.0909 10.9211 10.0906C10.9099 10.0845 10.8174 10.0644 10.7063 10.0417C10.6409 10.0283 10.5691 10.014 10.5037 10.0011C10.5036 10.0011 10.5037 10.0011 10.5037 10.0011C10.3843 9.97769 10.2859 9.95892 10.2859 9.95892L10.4922 9.06054L11.7002 9.31442L11.6993 9.31872C11.7901 9.33771 11.8822 9.35613 11.9754 9.37431C12.0231 9.38361 12.0711 9.39284 12.1193 9.40206C12.1655 9.41087 12.2118 9.41966 12.2584 9.42848L12.5763 8.04712L13.4517 8.23083L13.1402 9.58511C13.2804 9.61174 13.4212 9.63852 13.561 9.66607C13.6552 9.68464 13.7489 9.70356 13.8416 9.723L14.1509 8.37759L15.0268 8.56129L14.7091 9.94311ZM13.85 8.07311C13.9489 7.97555 14.0933 7.928 14.2391 7.95858L15.115 8.14228C15.2275 8.16587 15.3258 8.2337 15.3877 8.33049C15.4496 8.42728 15.47 8.54492 15.4442 8.65694L15.2138 9.65901C15.6477 9.81735 16.0521 10.023 16.3616 10.306C16.7836 10.692 17.0154 11.2116 16.9321 11.8678C16.8763 12.3118 16.7184 12.6783 16.4613 12.9584C16.4066 13.0181 16.3486 13.0724 16.2879 13.1219C16.443 13.2652 16.5747 13.4326 16.6713 13.6296C16.8941 14.0835 16.8918 14.6148 16.6935 15.2095C16.4367 15.9805 15.9541 16.4474 15.298 16.6613C14.7874 16.8278 14.1977 16.8323 13.5802 16.7634L13.3466 17.7783C13.2943 18.0058 13.0694 18.1495 12.841 18.1016L11.9652 17.9179C11.8526 17.8943 11.7544 17.8265 11.6925 17.7297C11.6776 17.7064 11.6651 17.6819 11.6551 17.6566C11.5561 17.7542 11.4117 17.8018 11.2658 17.7711L10.3909 17.5874C10.2785 17.5638 10.1803 17.496 10.1184 17.3992C10.0565 17.3025 10.0361 17.1849 10.0618 17.0729L10.2861 16.0963C10.2206 16.082 10.1546 16.0677 10.0871 16.0535C10.087 16.0535 10.0871 16.0535 10.0871 16.0535L8.94765 15.8144C8.82272 15.7882 8.71604 15.7077 8.65668 15.5947C8.59733 15.4818 8.59149 15.3482 8.64076 15.2305L9.04575 14.2625C9.12602 14.0706 9.33253 13.9641 9.53539 14.0098L9.63512 14.0322C9.69513 14.0456 9.77481 14.0632 9.85402 14.0805C9.93374 14.0979 10.011 14.1144 10.067 14.1257C10.0725 14.1268 10.0777 14.1279 10.0825 14.1288L10.5601 12.0527L10.5618 12.0448L10.9089 10.5349C10.8967 10.5288 10.8733 10.5193 10.8337 10.5109C10.8136 10.5067 10.7941 10.5011 10.7752 10.4942C10.7657 10.492 10.7529 10.4891 10.7365 10.4855C10.6814 10.4735 10.6046 10.4578 10.5248 10.4418C10.4456 10.426 10.3657 10.4104 10.3054 10.3987L10.2328 10.3847L10.2058 10.3795C10.0916 10.3578 9.99074 10.2904 9.9272 10.193C9.86365 10.0957 9.84246 9.97669 9.86849 9.86336L10.0748 8.96499C10.1271 8.73741 10.3521 8.59354 10.5806 8.64157L11.7885 8.89545C11.8086 8.89967 11.828 8.90522 11.8467 8.91199C11.8756 8.91791 11.9046 8.92379 11.9338 8.92964L12.1589 7.95137C12.2113 7.72394 12.4362 7.58019 12.6646 7.62813L13.5399 7.81184C13.6524 7.83545 13.7507 7.90328 13.8126 8.00008C13.8275 8.02334 13.84 8.04781 13.85 8.07311ZM9.6651 14.4458C9.67519 14.4094 9.68939 14.3771 9.70581 14.3487C9.68805 14.3797 9.67449 14.4124 9.6651 14.4458ZM14.1773 14.4499C14.2053 14.3281 14.1808 14.2537 14.1312 14.1859C14.0688 14.1007 13.9491 14.0073 13.7587 13.9169C13.4358 13.7636 13.0258 13.6708 12.6773 13.603L12.4408 14.6309C12.7727 14.7007 13.1694 14.7698 13.5215 14.7612C13.7438 14.7558 13.907 14.7196 14.0126 14.6639C14.1004 14.6176 14.1525 14.5578 14.1773 14.4499ZM12.3448 15.0484C12.2548 15.0293 12.1715 15.0107 12.0973 14.9941C12.033 14.9797 11.9755 14.9668 11.9265 14.9566C11.9265 14.9566 11.9265 14.9566 11.9265 14.9566L12.3525 13.105C12.4121 13.1175 12.485 13.1311 12.5675 13.1464C13.3062 13.284 14.82 13.5658 14.5947 14.5456C14.3976 15.4045 13.1221 15.2126 12.3448 15.0484ZM14.2234 11.9444C14.2984 11.9068 14.3464 11.857 14.3706 11.7521C14.3984 11.6314 14.3722 11.5675 14.3279 11.5115C14.2678 11.4356 14.151 11.3527 13.9656 11.2748C13.738 11.1793 13.4866 11.1207 13.2585 11.0757L13.0616 11.9316C13.284 11.9771 13.5338 12.0179 13.7744 12.0196C13.979 12.0211 14.1283 11.9921 14.2234 11.9444ZM12.9656 12.3492C12.8643 12.3284 12.7713 12.3074 12.691 12.2892C12.6369 12.277 12.5885 12.266 12.5473 12.2574C12.5473 12.2574 12.5473 12.2574 12.5473 12.2574L12.9335 10.578C12.9835 10.5885 13.0447 10.5997 13.114 10.6124C13.7305 10.7254 14.9928 10.9568 14.788 11.8477C14.6145 12.6015 13.6173 12.4824 12.9656 12.3492Z",
  fill: "#017654"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_35426_3734",
  x1: 25.9867,
  y1: 21.0927,
  x2: 4.45559,
  y2: 3.2981,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#337461"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AD1BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_35426_3734",
  x1: 25.9867,
  y1: 21.0927,
  x2: 4.45559,
  y2: 3.2981,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#337461"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AD1BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_35426_3734",
  x1: 28.1429,
  y1: 27.0157,
  x2: 0.164708,
  y2: -2.62909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#539984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#20E3AA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_35426_3734",
  x1: 28.1429,
  y1: 28.0904,
  x2: 5.00751,
  y2: 3.29713,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52AD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#14AE81"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_35426_3734",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.1803 12.529) rotate(-109.681) scale(11.1139 10.9833)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#53E7BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4CAD91"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_35426_3734",
  x1: 16.173,
  y1: 23.7608,
  x2: 7.33252,
  y2: 1.50592,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#489F85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63CBAC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_35426_3734",
  x1: 16.4877,
  y1: 19.697,
  x2: 4.76996,
  y2: 4.11784,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#489F85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63CBAC"
})));

var SvgBtcIcon = function SvgBtcIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtcIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btcIcon.d2d39552.svg";
export { ForwardRef as ReactComponent };